import React from 'react';
import { Link } from 'react-router-dom';
import CoinLogo from './CoinLogo';
import { CATEGORIES } from '../lib/categories';

export default function Footer() {
  return (
    <footer className="bg-surface-card border-t border-border-subtle">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-3">
              <CoinLogo size={48} animate={false} pauseOnHover={false} />
              <span className="font-clash text-xl font-semibold gold-text">
                CoinHustle Exchange
              </span>
            </Link>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
              The marketplace for modern hustlers. Buy, sell, and trade coins, precious metals, 
              cards, collectibles, and high-value assets.
            </p>
            <p className="mt-4 text-xs text-zinc-500">
              &copy; {new Date().getFullYear()} CoinHustle Exchange. All rights reserved.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-clash text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Categories
            </h4>
            <ul className="space-y-3">
              {CATEGORIES.map(cat => {
                const CatIcon = cat.icon;
                return (
                  <li key={cat.value}>
                    <Link 
                      to={`/marketplace?category=${cat.value}`}
                      className="text-sm text-zinc-400 hover:text-gold transition-colors flex items-center gap-2"
                    >
                      <CatIcon className="w-4 h-4" />
                      {cat.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-clash text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Platform
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/marketplace" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Browse Marketplace
                </Link>
              </li>
              <li>
                <Link to="/wanted" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Wanted Listings
                </Link>
              </li>
              <li>
                <Link to="/create-listing" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Sell an Item
                </Link>
              </li>
              <li>
                <Link to="/learn" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  How It Works
                </Link>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-clash text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Programs
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/dealer-program" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Dealer Program
                </Link>
              </li>
              <li>
                <Link to="/consignment" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Consignment
                </Link>
              </li>
              <li>
                <Link to="/grading" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Grading & Authentication
                </Link>
              </li>
              <li>
                <Link to="/learn" className="text-sm text-zinc-400 hover:text-gold transition-colors">
                  Beginner's Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border-subtle flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-zinc-500">
            &copy; {new Date().getFullYear()} CoinHustle Exchange. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">
            coinhustleexchange@gmail.com
          </p>
        </div>
      </div>
    </footer>
  );
}
